import styles from "./UserChatMessage.module.css";
import "./../Chat/ChatBox.css";
interface Props {
    message: string;
}

export const UserChatMessage = ({ message }: Props) => {
    return (
        <div className="chatbox">
            <div className="chat-container">
                <div className="chat-box">
                    <div className="chat-parent user">
                        <div className="cm-user-container">
                            <div className="cs-user">{message} </div>
                        </div>
                        <span className="user-polygon"></span>
                    </div>
                </div>
            </div>
        </div>
    );
};
